const en = {
  Brand: 'Reliance Telephone',

  OutboundCall: 'Outbound Call',
  InboundCall: 'Voicemail',

  TitlePostfix: ' | Relcore',
  TitleSearchOutbound: 'Search Inmate Calls',
  TitleSearchInbound: 'Search Voicemail',
  TitleSearchVisitation: 'Search Visitations',
  TitleSearchTexts: 'Search Texts',
  TitleVisitationsPending: 'Pending Visitations',
  TitleVisitationsManage: 'Visit Management',
  TitleInmates: 'Inmates',
  TitleDevices: 'Devices',
  TitleInmateNotifications: 'Inmate Notifications',

  Searching: 'Searching...',
  Loading: 'Loading...',

  CriteriaChoiceDestination: 'Destination',
  CriteriaChoicePhoneCard: 'Phone Card',
  CriteriaChoiceInmate: 'Inmate',
  CriteriaPlaceholderDestination: 'Phone number...',
  CriteriaPlaceholderPhoneCard: 'Phone card number...',
  CriteriaPlaceholderInmate: 'Inmate ID or name...',
  CriteriaPlaceholderBoxNumber: 'Box number...',

  BatchStarted:
    'The batch has started processing. You will be notified when it is complete.',
  BatchNotConnected:
    'We are unable to create the batch. The processing service is currently offline.',
  BatchCompleted: 'A batch was successfully processed.',

  BlockRemoved: 'The block was successfully removed.',
  BlockNotRemoved: 'The block was NOT removed.',
  BlockAdded: 'The block was successfully added.',
  BlockNotAdded: 'The block was NOT added.',
  BlockExisting: 'This number already has the requested block.',
  BlockFailure:
    'We were unable to automatically block this number in the  Reliance inmate phone system. Please try again later. If this is an emergency or this error continues, please call 888-773-6408',
  BlocksSearchFailure:
    'The Blocked Phone Numbers cannot currently be accessed due to a problem reaching the central Reliance Telephone system. If this problem continues, please contact Reliance Telephone at 888-773-6408.',

  PrivateNumberRemoved: 'The private number was successfully removed.',
  PrivateNumberNotRemoved: 'The private number was NOT removed.',
  PrivateNumberAdded: 'The private number was successfully added.',
  PrivateNumberNotAdded: 'The private number was NOT added.',
  PrivateNumberExisting: 'The private number already exists.',

  // Validation messages
  ValidateInvalidPhoneNumber: 'Please enter a valid phone number.',
  ValidateInvalidPhoneCard:
    'Please enter a valid numeric phone card (10 or less digits).',
  ValidateInvalidFriendlyDate: 'MM/DD/YYYY',

  TabReports: 'Reports',
  TabTools: 'Report',
  TabAlerts: 'Alerts',
  TabBlocks: 'Blocks',
  TabPhoneControl: 'Phone Control',
  TabPrivateNumbers: 'Private Numbers',
  TabSupport: 'Support',
  TabBatches: 'Batches',
  TabPhoneCards: 'Phone Cards',
  TabInmates: 'Inmates',
  TabInmateNotifications: 'Inmate Notifications',

  NoResults: 'No results were found',
  NoResultsBatches: 'No recording batches have been created.',
  NoResultsOutbound:
    'No calls found. Expand the search criteria or try your search later when there are records to match.',
  NoResultsInbound:
    'No voicemail found. Expand the search criteria or try your search later when there are records to match.',
  NoResultsVisitation:
    'No visitations found. Expand the search criteria or try your search later when there are records to match.',
  NoPendingVisitations: 'No visitations needing approval.',
  NoUpcomingVisitations: 'No upcoming visitations.',
  NoResultsVisitationManage: 'No current visitations',
  NoResultsText:
    'No text messages found. Expand the search criteria or try your search later when there are records to match.',
  NoResultsBlocks:
    'No blocks found. Expand the search criteria, add a new one above, or try your search later when there are records to match. ',
  NoResultsPrivateNumbers:
    'No private numbers found. Expand the search criteria, add a new one above, or try your search later when there are records to match. ',
  NoResultsInmates:
    'No inmates found. Expand the search criteria or try your search later when there are inmates to match.',
  NoResultsInmateNotifications:
    'No inmate notifications are currently active or upcoming.',
  NoResultsInmateContacts: 'This inmate does not have any contacts.',
  NoResultsInmateRequests:
    'No inmate requests found. Expand the search criteria or try your search later when there are records to match.',
  NoResultsAcknowledgements:
    'No inmate acknowledgements found. Expand the search criteria or try your search later when there are records to match.',

  ResultsApiError:
    'The results cannot currently be accessed due to a problem reaching the central Reliance Telephone system. If this problem continues, please contact Reliance Telephone at 888-773-6408.',

  PhoneCardNotFound: 'The phone card specified is not valid.',

  CommissaryTransferSuccess:
    'The commissary transfer was successfully recorded.',

  CommissaryTransfers: 'Commissary Transfers',

  AlertAdded: 'The alert was successfully added.',

  NoResultsMobileDeviceUsage: 'No usage results found',
};

export function setString(key: string, value: string) {
  en[key] = value;
}

export function getString(key: string): string {
  return en[key];
}
